import { axiosNewMechInstance, setJWTAuthHeader } from './api.js';

export async function refreshTokenRequest() {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('NO_REFRESH_TOKEN');
  }

  const response = await axiosNewMechInstance.post('/api/v1/auth/refresh', {
    refresh_token: refreshToken,
  });

  const { access_token, refresh_token } = response.data;

  localStorage.setItem('accessToken', access_token);
  localStorage.setItem('refreshToken', refresh_token);
  setJWTAuthHeader(access_token);

  return access_token;
}
